import React from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import Map from './map/Map';
import PageNotFound from '../components/404page/page-not-found';
//import { esriOauthAppId_AGOL,esriOauthAppId_OCPWPORTAL } from '../config';
import Home from '../components/home/home';
//import { cornerRecordMapConfig, omMapConfig, surveyMapConfig, surveyLiteConfig, demoSurveyMapConfig,assessorMapConfig, surveyFieldServicesMapConfig } from './map/PageConfiguration';
import Forbidden from '../components/403page/Forbidden';
import OpenLink from '../components/open-link/OpenLink';
import InternalServerError from '../components/500page/InternalServerError';
import AppPage from './app-page/AppPage';


const PageRoutes = () => {
  return (
//
      <Routes>
        <Route path="/" element={<OpenLink url={`${process.env.REACT_APP_BASE_DOMAIN_URL}/home`}></OpenLink>} />
        {/* <Route path="/" element={<Navigate replace to="./map-viewer?id=2" />} /> */}
        <Route path="home" element={<></>} />
        <Route path="/map-viewer" element={<AppPage/>} />
        <Route path="403" element={<Forbidden/>}/>
        <Route path="500" element={<InternalServerError/>}/>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
  )
}

export default PageRoutes